import axios from "axios";
import appConfig from "appConfig";

// withCredentials: wymagane by przegladarka odsylala cookie antiforgery (XSRF) przy POST.
// Brak auth uzytkownika - portal jest publiczny (kazdy z numerem zlecenia widzi status).
export default axios.create({
  baseURL: appConfig.BASE_URI,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
